<template>
  <Loading :active="true" :lock-scroll="true" :opacity="$route.name.includes('user') ? 0.5 : (opacity || 1)" color="rgb(255,45,32)"></Loading>
</template>
<script setup>
defineProps(['opacity']);
</script>

